import {useFetch} from "./useFetch";
import {useStore} from "./useStore";
import {useEffect, useMemo} from "react";

export const useCitiesForPools = () => {
    const stores = useStore();
    const citiesValue = localStorage.getItem("citiesForPools");
    const citiesData = useMemo(() => {
        if (!citiesValue) return;
        return JSON.parse(citiesValue);
    }, [citiesValue]);
    const [loading, citiesForPoolsData] = useFetch({
        defaultDataValue: citiesData?.data ?? [],
        fetchFn: stores.userStore.getAuthorizedPoolCities.bind(null),
        dependencies: [],
        condition: !citiesData || !(citiesData.expiresAt && citiesData.expiresAt > Date.now()),
        transform: (res) => {
            if (!res || !res.cities) return;
            localStorage.setItem("citiesForPools", JSON.stringify({
                data: res.cities,
                expiresAt: Date.now() + 24 * 60 * 60 * 1000
            }));
            return res.cities;
        }
    });

    return {loading, cities: citiesForPoolsData};
}